import * as THREE from 'three'
import { ThreeItemKeys, ThreeItemTypes } from '../constants/three'

export const getSceneLights = () => {
  const lightsGroup = new THREE.Group()
  lightsGroup.name = 'Lights'
  lightsGroup.userData[ThreeItemKeys.ITEM_TYPE] = ThreeItemTypes.LIGHTS

  // 🌤️ Ambient light — soft global illumination
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.4)
  lightsGroup.add(ambientLight)

  // ☀️ Main sunlight (directional)
  const sunLight = new THREE.DirectionalLight(0xffffff, 1.2)
  sunLight.position.set(15, 20, 10)
  sunLight.castShadow = true
  sunLight.shadow.mapSize.set(2048, 2048)
  sunLight.shadow.camera.near = 1
  sunLight.shadow.camera.far = 100
  sunLight.shadow.camera.left = -30
  sunLight.shadow.camera.right = 30
  sunLight.shadow.camera.top = 30
  sunLight.shadow.camera.bottom = -30
  sunLight.shadow.bias = -0.0005
  lightsGroup.add(sunLight)

  // 🌇 Warm fill light (to add contrast and avoid harsh shadows)
  const fillLight = new THREE.DirectionalLight(0xffbbaa, 0.6)
  fillLight.position.set(-10, 5, -10)
  lightsGroup.add(fillLight)

  // 💡 Overhead light (optional for indoor/neutral scenes)
  const topLight = new THREE.PointLight(0xffffff, 0.3)
  topLight.position.set(0, 10, 0)
  lightsGroup.add(topLight)

  // DEV visualization helpers
  // if (import.meta.env.DEV) {
  //   lightsGroup.add(new THREE.DirectionalLightHelper(sunLight, 2, 'red'))
  //   lightsGroup.add(new THREE.DirectionalLightHelper(fillLight, 2, 'red'))
  //   lightsGroup.add(new THREE.PointLightHelper(topLight, 0.5, 'red'))
  // }

  return lightsGroup
}

export const isSceneLights = (object: THREE.Object3D) => {
  return object.userData[ThreeItemKeys.ITEM_TYPE] === ThreeItemTypes.LIGHTS
}
